<template>
    <div class="body">
        <template>
            <el-carousel ref="carousel" type="card" height="450px" :autoplay="false"  arrow="never" >
                <el-carousel-item v-for="(item,index) in list" :key="index" class="carouse">
                    <div class="card" id="card" :style = "{background:'url('+item.cardUrl+') center center no-repeat'}">
                        
                        <!-- 黑金卡 -->
                        <!-- <div class="black" :style="{'visibility':black}">
                            <span class="userNameB blackUser">{{item.cardUser.name}}</span>
                            <span class="timeB blackUser">{{item.cardUser.str}}{{item.cardUser.time}}</span>
                            <span class="numB blackUser">{{item.cardUser.number}}</span>
                        </div> -->

                        <!-- 钻石卡 -->
                        <div class="diamond" :style="{'visibility':diamond}">
                            <span class="userNameD diamondUser">{{item.cardUser.name}}</span>
                            <span class="timeD diamondUser">{{item.cardUser.str}}{{item.cardUser.time}}</span>
                            <span class="numD diamondUser">{{item.cardUser.number}}</span>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </template>

        <p class="addVip">会员添加</p>
        <el-form ref="form"  label-width="80px" class="form">
                    <label>会员类型:</label>
                    <el-select v-model="card.roleId" placeholder="请选择" class="selectInput" >
                        <el-option  v-for="(item,index) in options" :key="index"  :label="item.name"  :value="item.id" @click.native="optionsSlide(index)"></el-option>
                    </el-select>
                    <br/>
                    <label>会员卡号:</label>
                    <el-input v-model="card.vipNum" class="textInput" placeholder="请输入内容"></el-input>
                    <br/>
                    <label>电话号码:</label>
                    <el-input v-model="card.phone" class="textInput" placeholder="请输入内容"></el-input>
                    <br/>
                    <label>会员姓名:</label>
                    <el-input v-model="card.userName" class="textInput" placeholder="请输入内容"></el-input>
                    <br/>
                    <label>员工姓名:</label>
                    <el-input v-model="card.entryName" class="textInput" placeholder="请输入内容"></el-input>
                    <br/>
                    <el-button type="primary" class="butonInput" @click="sendCard" >立即创建</el-button>
        </el-form>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            list:[],
            options: [],
            value: null,
            black:'hidden',
            diamond:'hidden',
            input:'',
            card:{
                phone:'',
                vipNum:'',
                userName:'',
                roleId:'',
                entryName:''
            }
        }
    },
    mounted(){
        this.cardList();
    },
    methods:{
        optionsSlide(value){
             this.$refs.carousel.setActiveItem(value) 
        },
        //卡列表
        cardList(){
            this.joker.card.cardList().then(res=>{
                console.log(res)
                this.options = res.content
                this.list = res.content
            })
        },
        //添加会员
        sendCard(){
            console.log( this.card)
            let that = this
            this.joker.card.addCard(that.card).then(res=>{
                console.log(res)
                that.list = res.content
                if(res.content[0].cardUser.name!=null){
                     that.diamond = 'hidden'  
                     that.black = 'visible'
                }else if(res.content[1].cardUser.name!=null){
                    that.black = 'hidden'  
                    that.diamond = 'visible'
                }
            })
        }
    }
}
</script>

<style scoped>

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .card{
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      position: fixed;
      filter: brightness(90%);
  }

  .carouse{
     width: 57%;
     border-radius:20px;
  }

  .selectInput{
      width: 20%;
  }

  .textInput{
      width: 20%;
      margin-top: 1%;
  }

  .butonInput{
      margin-top: 1%;
  }

  .addVip{
      font-size: 26px;
  }

  .form{
      margin-top: 1%;
  }

  .diamondUser{
        float: left;
        font-size: 30px;
        color: #000000;
        font-family: '黑体';
  }

  .userNameD{
      position:absolute;
       margin-top: 5%;
       margin-left: -16%;
       font-size: 35px;
       font-weight: 900;
       z-index: 1
  }

  .timeD{
      position:absolute;
      z-index: 2;
      margin-top: 44%;
      margin-left:-48%;
  }

  .numD{
      position:absolute;
      margin-top: 40%;
      margin-left: -47%;
       z-index: 3;
  }

  .blackUser{
       float: left;
        font-size: 30px;
        color: #ffffff;
        font-family: '黑体';
  }

  .userNameB{
      position:absolute;
       margin-top: 2%;
       margin-left: -22%;
       font-size: 35px;
       font-weight: 900;
       z-index: 1
  }

  .timeB{
      position:absolute;
      margin-top: 44%;
      margin-left: 15%;
       z-index: 3;
  }

  .numB{
      position:absolute;
      z-index: 2;
      margin-top: 44%;
      margin-left:-45%;
  }


</style>


// WEBPACK FOOTER //
// src/components/Card/SendCard.vue